export default "__VITE_ASSET__521836b7__"